<template>
    <div class="intelligent-wearable-box">
        <div class="intelligent-wearable-content-wrapper">
            <Ptitle :chineseTitle="title.chinese" :enTitle="title.english" ></Ptitle>
            <!-- <Ptitle :mainTitle="title.main" :viceTitle="title.vice"></Ptitle> -->
            <div class="intelligent-wrapper">
                <div class="intelligent-box" :class="[(item.title == isActive || !isActive) ? '' : 'unactive']"
                    v-for="(item,index) in intelligentList" :key="index">
                    <div class="img-box">
                        <img :src="item.url" alt="">
                    </div>
                    <div class="text-box">
                        <div class="title">{{ item.title }}</div>
                        <div class="introduce">{{ item.introduce }}</div>
                        <div class="register" @click="clickRegister(index)">
                            <img src="../../../assets/images/safety.png" alt="">
                            {{ item.register }}
                        </div>
                    </div>
                    <div class="shop-icon" @click="handleShop(item)">
                        <img src="../../../assets/images/shop_icon@2x.png" alt="">
                    </div>
                    <div class="buy-code" :class="item.title == showCode ? 'active' : ''">
                        <img src="../../../assets/images/buy_popover.png" alt="">
                        <div class="code-box">
                            <img :src="item.code" alt="">
                        </div>
                        <div class="code-title">
                            <p>{{ item.codeTitle }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showPayModal">
            <payBox  @closeLogin="closeLogin" :fromType="fromType"></payBox>
        </div>
    </div>
</template>

<script>
// import Ptitle from "../../../components/header/pictureTitle.vue"
import Ptitle from "../../../components/header/title.vue"
import payBox from '../../../components/payBox/index'

export default {
    name: "",
    data() {
        return {
            showPayModal:false,
            fromType:'center',
            isActive: "",
            showCode: "",
            title: {
                main: "智能穿戴",
                vice: "居家检测，数据实时上传"
            },
            intelligentList: [
                {
                    url: require("../../../assets/images/wear_01.png"),
                    title: "胎儿监护仪",
                    introduce: "适用于孕晚期胎儿心率、胎动和孕妇宫缩压力的连续监护",
                    register: "注册证(粤械注准20142180065)",
                    code: require("../../../assets/images/wearCode_01.png"),
                    codeTitle: "商品详情"
                },
                {
                    url: require("../../../assets/images/wear02.png"),
                    title: "多体征采集器",
                    introduce: "可使用测量血压、血氧、血糖、脉率等多种数据",
                    register: "注册证(粤械注准20162070961)",
                    code: require("../../../assets/images/wearCode_02.png"),
                    codeTitle: "商品详情"
                },
                // {
                //     url: require("../../../assets/images/wear03.png"),
                //     title: "排卵试纸",
                //     introduce: "智能预测女性排卵时间，智能提醒，掌控黄金受孕时机",
                //     register: "注册证(津械注准20202400908)",
                //     code: require("../../../assets/images/wearCode_03_01.png"),
                //     codeTitle: "商品详情"
                // }
            ],
              title: {
                chinese: '产品介绍',
                english: 'PRODUCTS'
            }
        }
    },
    components: {
        Ptitle,
        payBox

    },
    mounted() {
        document.addEventListener('click', () => {
            if (this.showCode) {
                this.showCode = "";
            }
        }, true)
    },
    methods: {
        closeLogin(){
          this.showPayModal=false;
        },
        enter(item) {
            this.isActive = item.title;
        },
        leave() {
            this.isActive = "";
        },
        show(item) {
            this.showCode = item.title;
        },
        handleShop(item) {
            let userInfo = localStorage.getItem('userInfo') ? localStorage.getItem('userInfo') : '{}'
            userInfo = JSON.parse(userInfo)
            if (!userInfo.email) {  // 未登录
              this.$toast('请登录后付费查看',3000)
            } else if (userInfo.email==window.Glod.superAdmin.email) {
               // 直接查看
               let type = ''
               if (item.title == "胎儿监护仪") {
                  type = 1
               } else if (item.title == "多体征采集器") {
                  type = 2
               }
               this.$router.push({
                  name: 'product',
                  query: {
                     pageType: type,
                     title: item.title 
                  }
               })
            } else {
               //  弹窗支付
               this.showPayModal=true;
            }


        },
        clickRegister(e) {
            //this.$router.push({name: 'License'});
            let routeUrl = this.$router.resolve({
                path: "/register",
                query: {
                pageType: e
                }
            });
            window.open(routeUrl.href, "_blank");
        }
    }
}
</script>

<style lang="scss">
.intelligent-wearable-box {
    width: 100%;
    min-height: 740px;
    background: #fff;
    position: relative;
    background-image: url("../../../assets/images/home_wear\ _base_map.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .intelligent-wearable-content-wrapper {
        width: 100%;
        height: 100%;
        margin-top: 80px;
        position: absolute;
        top: 0;
        z-index: 10;

        .intelligent-wrapper {
            margin: 0 200px;
            margin-top: 130px;
            display: flex;
            justify-content: space-around;

            .unactive {
                filter: opacity(50%);
            }

            .intelligent-box {
                display: flex;
                width: 470px;
                height: 300px;
                background: RGBA(241, 246, 255, 1);
                background-image: linear-gradient(to bottom, RGBA(241, 246, 255, 1)80%, #fff 20%);
                // background-clip:content-box;
                position: relative;
                box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.02);
                border-radius: 20px;

                // padding-bottom: 60px;
                // cursor: pointer;
                .img-box {
                    height: 300px;
                    width: 220px;

                    // position: absolute;
                    // top: 0;
                    // left: 0;
                    img {
                        height: 100%;
                        width: 100%;
                    }
                }

                .text-box {
                    margin-top: 50px;
                    text-align: left;
                    padding-right: 20px;
                    box-sizing: border-box;
                    flex: 1;

                    .title {
                        width: 100%;
                        height: 42px;
                        font-size: 28px;
                        font-weight: bold;
                        color: #222222;
                        line-height: 37px;
                    }

                    .introduce {
                        height: 44px;
                        font-size: 16px;
                        color: #222222;
                        line-height: 22px;
                        margin: 15px 0;
                    }

                    .register {
                        height: 19px;
                        font-size: 14px;
                        color: #222222;
                        line-height: 19px;

                        >img {
                            vertical-align: middle;
                            height: 16px;
                            width: 16px;
                        }
                    }
                    .register:hover {
                        font-weight: bold;
                        cursor: pointer;
                        >img {
                            vertical-align: middle;
                            height: 20px;
                            width: 20px;
                        }
                    }
                }

                .shop-icon {
                    height: 44px;
                    width: 44px;
                    position: absolute;
                    bottom: 82px;
                    right: 204px;
                    cursor: pointer;

                    >img {
                        height: 100%;
                        width: 100%;
                    }
                }

            }
            .buy-code {
                height: 162px;
                width: 160px;
                position: absolute;
                bottom: -150px;
                right: -0px;
                display: none;
                transform: scale(1.6);
                >img {
                    height: 100%;
                    width: 100%;
                }

                .code-box {
                    height: 100px;
                    width: 100px;
                    position: absolute;
                    top: 24px;
                    left: 30px;

                    >img {
                        height: 100%;
                        width: 100%;
                    }
                }

                .code-title {
                    width: 100%;
                    text-align: center;
                    position: absolute;
                    bottom: 12px;
                    left: 0px;
                    height: 25px;
                    font-size: 14px;
                    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                    font-weight: bold;
                    color: #FF789E;
                    line-height: 19px;
                }
            }
            .active {
                display: block;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/intelligentWearable.vue